export default __webpack_public_path__ + "static/media/black_and_white_woman.9b5924b2.jpg";